module.exports = __webpack_public_path__ + "static/ux_thumbnail-s-f2aa2639b3dba0f4b735d05b5a5fbedc.png";